const $ = require('jquery');

$(document).ready(function() {
    $('#responsive-menu-button').sidr({
        name: 'sidr-main',
        source: '#mobile-navigation',
        name: 'mobile-navigation',
        displace: false,
        side: 'right',
        speed: 320,
        renaming: false,
        onOpen: function () {
            $('body').addClass('mobileOpen');
        }

    });

    $('.closeMenu').on('click', function (e) {
        e.preventDefault();
        $.sidr('close', 'mobile-navigation');
        $('body').removeClass('mobileOpen');
    });
});